import { ChangeProjectPartDialogComponent } from './components/change-project-part-dialog/change-project-part-dialog.component';
import { ErpCommonModule } from './../../erp-articles/erp-common/erp-common.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ReactiveFormsModule } from '@angular/forms';
import { CommonTranslationModule } from '@sdbn/common';
import { ProjectAdminComponent } from './components/project-admin/project-admin.component';
import { MaterialModule, ServiceResponseModule } from '@sdbn/appclient';
import { WidgetRegistryService } from '@sdbn/appclient';
import { WidgetDefinition } from '@sdbn/appclient';
import { ProjectMasterdataComponent } from './components/project-masterdata/project-masterdata.component';
import { AddProjectDialogComponent } from './components/add-project-dialog/add-project-dialog.component';
import { ProjectStructureComponent } from './components/project-structure/project-structure.component';
import { AddProjectPartDialogComponent } from './components/add-project-part-dialog/add-project-part-dialog.component';
import { ProjectPositionEditorDialogComponent } from './components/project-position-editor-dialog/project-position-editor-dialog.component';
import { CommonDateModule } from '@sdbn/appclient';
import { PriceEditorComponent } from './components/project-position-editor-dialog/price-editor/price-editor.component';
import { NumberInputModule } from '@sdbn/appclient';
import { ChangeProjectDialogComponent } from './components/change-project-dialog/change-project-dialog.component';
import { ApplicationClientCommonModule } from '@sdbn/appclient';
import { ProjectSelectionHeaderComponent } from './components/project-selection-header/project-selection-header.component';
import { ProjectSelectionHeaderTabItemComponent } from './components/project-selection-header-tab-item/project-selection-header-tab-item.component';
import { AddProjectEditorComponent } from './components/add-project-editor/add-project-editor.component';
import { ProjectSelectionComponent } from './components/project-selection/project-selection.component';
import { CommonUIModule } from '@sdbn/common';
import { ProjectDetailsComponent } from './components/project-details/project-details.component';

@NgModule({
  declarations: [
    ProjectAdminComponent,
    ProjectMasterdataComponent,
    AddProjectDialogComponent,
    ProjectStructureComponent,
    AddProjectPartDialogComponent,
    ProjectPositionEditorDialogComponent,
    PriceEditorComponent,
    ChangeProjectDialogComponent,
    ChangeProjectPartDialogComponent,
    ProjectSelectionHeaderComponent,
    ProjectSelectionHeaderTabItemComponent,
    AddProjectEditorComponent,
    ProjectSelectionComponent,
    ProjectDetailsComponent
  ],
  imports: [
    CommonModule,
    CommonUIModule,
    MaterialModule,
    ReactiveFormsModule,
    CommonTranslationModule,
    CommonDateModule,
    NumberInputModule,
    ServiceResponseModule,
    ApplicationClientCommonModule,
    ErpCommonModule
  ]
})
export class ErpProjectModule {

  constructor(
    private widgetRegistryService: WidgetRegistryService
  ) {

    // register widgets
    widgetRegistryService.registerWidget(new WidgetDefinition({
      key: 'erpProjectAdmin',
      name: 'Projects Admin',
      description: 'TBD',
      icon: 'fa-light fa-list-tree',
      groupIdentifier: 'erp-project',
      widgetComponent: ProjectAdminComponent,
      editorComponent: null,
      autoreload: false
    }));

  }

}
